import PubNub from "pubnub";

const pubNubInstace = new PubNub({
  subscribeKey: process.env.VUE_APP_PUBNUB_SUBSCRIBE_KEY,
  uuid: "5dea55d9-acd5-44f3-9d7a-3b7254cf4594",
});

export default pubNubInstace;
